import React from "react";
import { TextLabel } from "../style";
import { StandardModalFormGroup, StandardModalInput } from "src/components";
import RichTextEditor from "src/components/RichTextEditor/RichTextEditor";
import styled from "styled-components";

const ResponsiveContainer = styled.div`
    width: 100%;
    min-width: 0;
    display: grid;
    gap: 1rem;
`;

const StyledTitleInput = styled(StandardModalInput)`
    width: 100%;
    height: 42px;
`;

const EditorShell = styled.div`
    width: 100%;
    min-width: 0;
    overflow-x: hidden;

    > div {
        max-width: 100%;
        overflow-x: hidden;
        box-sizing: border-box;
    }

    [data-slate-editor="true"] {
        overflow-x: hidden !important;
        word-break: break-word;
        overflow-wrap: anywhere;
    }
`;

export default function ContentForm({
    title,
    onTitleChange,
    htmlDescription,
    setHtmlDescription,
    errors,
}) {
    return (
        <ResponsiveContainer width="100%">
            <StandardModalFormGroup>
                <TextLabel fontSize="0.875rem" fontWeight="700" marginBottom="0">Title</TextLabel>
                <StyledTitleInput
                    type="text"
                    placeholder="Enter the title of this content"
                    onChange={(e) => onTitleChange(e)}
                    maxLength="100"
                    value={title}
                    name="title"
                />
                <TextLabel color="red" fontSize="0.8125rem" fontWeight="500" marginBottom="0">
                    {errors.title}
                </TextLabel>
            </StandardModalFormGroup>
            <StandardModalFormGroup>
                <TextLabel color="#000000" fontSize="0.875rem" fontWeight="700" marginBottom="0">
                    Description
                </TextLabel>
                <EditorShell>
                    <RichTextEditor
                        setContent={setHtmlDescription}
                        initialValue={htmlDescription}
                        placeholder="Enter a description for this content"
                    />
                </EditorShell>
                <TextLabel color="red" fontSize="0.8125rem" fontWeight="500" marginBottom="0">
                    {errors.description}
                </TextLabel>
            </StandardModalFormGroup>
        </ResponsiveContainer>
    );
}
